/* eslint-disable react/prop-types */
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoutes = ({ user }) => {
  const location = useLocation();

  if (!user.isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (user.passwordChanged === false && location.pathname !== '/password-reset') {
    return <Navigate to="/password-reset" replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
